<template>
  <div class="model-title">{{ $t('CustomSpus.ShoppingCartAddress.shippingAddress') }}</div>
  <div class="square-div">
    <div v-if="selectAddress"
         class="box-border">
      <div class="box-flex">
        <div>
          <span class="box-margin address-font">{{ selectAddress?.name }}</span>
          <span class="address-font">{{ selectAddress?.phone }}</span>
        </div>
        <div>
          <span>{{ selectAddress?.province.name }}</span>
          <span>{{ selectAddress?.city.name }}</span>
          <span> {{ selectAddress?.district.name }}</span>
          <span> {{ selectAddress?.street.name }}</span>
          <span>{{ selectAddress?.address }}</span>
        </div>
      </div>
      <div class="box-edit"
           @click="changeAddress()">{{ $t('CustomSpus.ShoppingCartAddress.edit') }}
      </div>
    </div>
    <a-button v-else
              type="primary"
              @click=changeAddress()>{{ $t('CustomSpus.ShoppingCartAddress.addNewAddress') }}</a-button>
  </div>
  <div class="table-container">
    <div>{{ $t('CustomSpus.ShoppingCartAddress.selectProduct') }}</div>
    <div ref="hiddenContainer"
         class="hiddenAddressOrder"></div>
    <a-table :columns="orderColumns"
             row-key="id"
             :data-source="selectedItems"
             :row-selection="rowSelection"
             :pagination="false"
             class="address-table">
      <template #bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'customImages'">
          <div class="flex-box">
            <div v-if="!isDesign"
                 class="image-box">
              <div v-if="hiddenContainer && record.is_custom"
                   class="viewer">
                <image-customize-viewer :id="record.id + ''"
                                        mode="view"
                                        :container="hiddenContainer"
                                        :template-basic-parameters="templateBasicParameters(toUrl(record.spu_customable_image)!, colorOfItem(record)?.value!, record.spu_custom_width, record.spu_custom_height)"
                                        :custom-area="assignCustomizedData(record.spu_custom_areas, record.spu_custom_width, (record.customized_areas.customable_image_scale || record.spu_custom_areas.scale), record.customized_areas.boundingRect)"
                                        :customized-image="renderImageCustomUrl(record)" />
              </div>
              <img v-else
                   :src="toUrl(record.image)"
                   class="viewer" />
            </div>
            <div class="item-flex">
              <div class="name_color">
                {{ record.spu_name }}
              </div>
              <div>
                <span v-for="(attr, index) in convertAttrs(record.sku_attrs)"
                      :key="index">
                  {{ attr.name }}:<span class="attr_color">{{ attr.value }}</span>
                </span>
                <span v-if="isDesign">
                  <span v-for="tec in record.technology"
                        :key="tec.id"
                        style="">{{ tec.customableImageName }}:<span class="attr_color">{{ tec.name }}</span></span>
                </span>
              </div>
            </div>
          </div>
        </template>
        <template v-if="column.dataIndex === 'quality'">
          <a-input-number v-model:value="record.quality"
                          :min="1"
                          :max="record.maxQuality"
                          @change="onUpdate(record.quality, record)" />
        </template>
      </template>
    </a-table>
  </div>
  <a-modal v-model:visible="addressPut"
           :title="$t('CustomSpus.ShoppingCartAddress.addNewAddress')"
           :centered='true'
           :cancel-text="$t('CustomSpus.ShoppingCartAddress.return')"
           width="754px"
           :destroy-on-close="true"
           :body-style="{ padding: 0, height: '600px' }">
    <AddressViewer ref='addressRef'
                   :is-cart="true"
                   :is-add="isAdd"
                   :select-id="selectId"
                   @close-add-modal="closeAdd">
    </AddressViewer>
    <!-- </a-radio-group> -->
    <template #footer>
      <a-button class="modal-btn btn-bgc"
                @click="addressCancel">{{ $t('CustomSpus.ShoppingCartAddress.cancel') }}</a-button>
      <a-button type="primary"
                class="modal-btn"
                @click="addressShow">{{ $t('CustomSpus.ShoppingCartAddress.confirm') }}</a-button>
      <a-button class="modal-btn btn-bgc"
                @click="addressAdd">{{ $t('CustomSpus.ShoppingCartAddress.addNewAddress') }}</a-button>
    </template>
  </a-modal>
</template>


<script lang="ts" setup>
import { toUrl } from '@/utils'
import { ImageCustomizeEditor as ImageCustomizeViewer } from '@iota-cn/ui-components'
import { message } from 'ant-design-vue'
import { computed, ref, watch } from 'vue'
import AddressViewer from '../../../order-info/address/view/AddressesList.vue'
import { fetchAddresses } from '../../api'
import type { Color } from '../../types'
import { assignCustomizedData, convertColor, renderImageCustomUrl, sortBy, templateBasicParameters } from '../../utils'
import { useI18n } from "vue-i18n"
const { t } = useI18n()
const props = defineProps({
  selectedItems: Array,
  allExpressData: Array,
  isDesign: Boolean,
})

if (props.selectedItems && props.selectedItems.length > 0) {
  props.selectedItems?.forEach((item: any) => {
    item.maxQuality = item.quality
  })
}

const emit = defineEmits(['selectOrder', 'selectAddress'])


const selectedRowKeys = ref<any>([])
const hiddenContainer = ref()
const addressRef = ref()
const addressPut = ref(false)
const addresses = ref<any>([])
const selectAddress = ref<any>()
const isAdd = ref<boolean>(false)
const selectId = ref<number>(0)

const onSelectChange = (selectedKeys: any) => {
  selectedRowKeys.value = selectedKeys
  if (props.selectedItems) {
    const selectedData = props.selectedItems.filter((item: any) => selectedRowKeys.value.includes(item.id))
    emit('selectOrder', selectedData)
  }

}

const rowSelection = {
  selectedRowKeys,
  onChange: onSelectChange,
}

const orderColumns = computed(() => [
  {
    title: t('CustomSpus.ShoppingCartAddress.productInfo'),
    dataIndex: 'customImages',
    align: 'center',
    width: '80%',
  },
  {
    title: t('CustomSpus.ShoppingCartAddress.quantity'),
    dataIndex: 'quality',
    align: 'center',
    width: '20%',
  }
])

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const colorOfItem = (item: any): Color | undefined => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const colorAttr = item.sku_attrs?.find((a: any) => {
    return a.attribute.key === 'color'
  })
  if (colorAttr) {
    return convertColor(colorAttr.value || colorAttr.object_value)
  }
  return undefined
}

const onUpdate = (value: number, record: any) => {
  if (value <= record.quantity) {
    record.quantity = value
  }
}


const convertAttrs = (attrs: any[]) => {
  const arr = [] as any
  attrs.forEach((a) => {
    const data = {
      name: '',
      value: ''
    }
    data.name = a.attribute.name
    data.value = a.object_value ? a.object_value.name : a.value
    arr.push(data)
  })
  arr.sort(sortBy('name', false))
  return arr
}


watch(() => addressRef.value?.address, (state) => {
  if (state && (state?.name != '' || state?.phone != '' || state?.address != '')) {

    if (props.allExpressData) {
      let matchAddress = false
      for (let i = 0; i < props.allExpressData.length; i++) {
        const currentAddress = (props.allExpressData[i] as any)[0]
        if (JSON.stringify(currentAddress.address) === JSON.stringify(state)) {
          matchAddress = false
          message.error(t('CustomSpus.ShoppingCartAddress.duplicateAddress'))
          break
        } else {
          matchAddress = true
        }
      }
      if (matchAddress) {
        selectAddress.value = state
      }
    }
    // addressPut.value = !addressPut.value
  }
}, { deep: true })

const changeAddress = async () => {
  addressPut.value = true
  const res: any = await fetchAddresses()
  addresses.value = res.addresses
}

const addressAdd = () => {
  isAdd.value = true
}
const closeAdd = () => {
  isAdd.value = false
}

const addressCancel = () => {
  addressPut.value = false
}

const addressShow = () => {
  emit('selectAddress', selectAddress.value)
  addressPut.value = false
}

</script>

<style scoped lang="less">
.model-title {
  margin-top: 10px !important;
  width: 95%;
  margin: auto;
  font-size: 14px;
  font-weight: 400;
  color: #111111;
}

.table-container {
  width: 95%;
  margin: auto;

  :deep(.ant-table-tbody) {
    font-size: 13px;
    color: #696768;
  }

  .viewer {
    width: 72px;
    height: 72px;
    display: flex;
    justify-content: center;
    align-items: center;

    @-moz-document url-prefix() {
      :deep(.fabric-div) {
        width: 72px !important;
        height: 72px !important;
      }

      :deep(.canvas-container) {
        width: 72px !important;
        height: 72px !important;
      }

      :deep(.lower-canvas) {
        width: 72px !important;
        height: 72px !important;
      }

      :deep(.upper-canvas) {
        width: 72px !important;
        height: 72px !important;
      }
    }
  }

  .flex-box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: 30px;

    .image-box {
      width: 80px;
      height: 80px;
      background-color: #F6F6F6;
      display: flex;
      justify-content: center;
      align-items: center;
      flex: none;
    }

    .item-flex {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-start;
      margin-left: 20px;
      text-align: start;

      .name_color {
        font-size: 16px;
      }

      .attr_color {
        color: #999;
        margin-right: 5px;
      }
    }
  }

  :deep(.ant-table-tbody .ant-table-cell) {
    height: 116px !important;
    padding: 0;
  }

  .quantity-input {
    width: 124px;
    text-align: center;

    :deep(.ant-input-group-addon) {
      padding: 0;
      width: 32px;
      height: 32px;
    }

    :deep(.ant-input) {
      height: 32px;
      padding: 0;
    }

    .input-change {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      background-color: #F6F6F6;
    }

    .input-disabled {
      cursor: not-allowed;
    }
  }
}

.square-div {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 95%;
  height: 100px;
  border: 2px dashed lightgray;
  margin: 20px;
}

.hiddenAddressOrder {
  width: 72px;
  height: 72px;
  position: absolute;
  visibility: hidden;
  display: block;
}

.box-border {
  padding-left: 14px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  :deep(.ant-radio-wrapper) {
    align-items: center;
  }

  .box-flex {
    height: 64px;
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
  }

  .box-margin {
    height: 64px;
    border: 1px solid #F1F1F1;
    margin-right: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .address-font {
    font-family: 'Microsoft YaHei Bold';
    border: none;
  }

  .box-edit {
    width: 64px;
    height: 64px;
    line-height: 64px;
    text-align: center;
    color: #999999;
    cursor: pointer;
  }

  .box-edit:hover {
    background: #F1F1F1;
  }
}
</style>
